<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="dashboard">
      <a-col>
        <a-card :title="$t('cardTitle.howToOrderCards')" class="reset-padding style3">
          <iframe src="https://player.vimeo.com/video/558284900" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </a-card>
      </a-col>
    </a-row>
    <a-spin tip="Loading..." :spinning="isLoading" size="large">
      <div class="spin-content">
        <a-row :gutter="20" class="dashboard">
          <a-col>
            <a-card :title="`${$t('cardTitle.cardOrderForm')}`" class="style3 loading">
              <Cards
                v-if="userCardOrder.length > 0 && !isShowCardOrder"
                :card-items="userCardOrder"
                @onAddNewCard="isShowCardOrder = true"
                :data-sources="dataSources"
                @onUpdated="doInitData"
                @onImgSource="doGetImgSource"
              />
              <template v-if="isShowCardOrder">
                <Invitation ref="invitation" v-model="dataInput" @onImgSource="doGetImgSource" :data-sources="dataSources" />
              </template>
              <CoolLightBox :items="items" :index="index" @close="index = null" :disable-zoom="true" :close-on-click-outside-mobile="true" />
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import Invitation from './Invitation';
import Cards from './Cards';
import CardOrderService from '@/services/CardOrderService';
import { groupBy } from 'lodash';
export default {
  components: {
    Invitation,
    Cards,
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  data: () => ({
    dataInput: {},
    items: [],
    index: null,
    imgType: '',
    userCardOrder: [],
    isShowCardOrder: false,
    isLoading: true,
    dataSources: {},
  }),
  methods: {
    openLink(url, isLink = false) {
      if (isLink) {
        window.location.href = url;
      } else {
        this.$router.push({ name: url });
      }
    },
    doGetImgSource(source) {
      this.items = [
        {
          src: source.url,
          title: source.name,
        },
      ];
      this.index = 0;
    },
    async doInitData() {
      try {
        this.isLoading = true;
        const resp = await CardOrderService.doGetCard({ user_id: this.user.userId });
        this.userCardOrder = resp;
      } catch (error) {
        console.log({ error });
      } finally {
        this.isShowCardOrder = this.userCardOrder.length === 0;
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      const respCards = await CardOrderService.doGetCardDesigned('individual');
      this.dataSources = {
        ...groupBy(respCards, 'cardtype'),
      };
      await this.doInitData();
    } catch (error) {
      console.log({ error });
    } finally {
      this.isShowCardOrder = this.userCardOrder.length === 0;
      this.isLoading = false;
    }
  },
};
</script>
<style lang="scss">
.dashboard-container.content-page {
  padding: 0 !important;
  .dashboard {
    padding: 20px;
    .ant-btn {
      height: 100%;
      white-space: initial;
    }
    .loading {
      min-height: 120px;
    }
  }
  .cool-lightbox .cool-lightbox__slide .cool-lightbox__slide__img {
    width: auto;
  }
}
</style>
